import React from 'react';

import * as S from '../components/styles.css';
import createSlug from '../utils/createSlug';
import { stripOuterTags } from '../utils/stripHtml';
import Layout from '../components/layout';
import Seo from '../components/seo';
import Pagination from '../components/pagination';
import renderList from '../components/renderList';
import AuthorContact from '../components/authorContact';

const BlogAuhor = ({ data, pageContext }) => {
  const { currentPage, numPages, author, posts, canonicalUrl, nextUrl, prevUrl } = pageContext;

  return (
    <Layout>
      <Seo title={'Inlägg av ' + author.name} canonicalUrl={canonicalUrl} nextUrl={nextUrl} prevUrl={prevUrl} />

      <S.Author>Om skribenten</S.Author>

      <div style={{ marginBottom: '30px', marginTop: '20px', borderBottom: '1px solid #eee', paddingBottom: '10px' }}>
        <h1>{author.name}</h1>
        <div style={{ paddingLeft: '20px', float: 'right' }}>
          <img
            src={author.image?.localFile.childImageSharp.fixed.src}
            alt={author.name}
            style={{ maxWidth: '100px', borderRadius: '100px' }}
          />
        </div>
        <p dangerouslySetInnerHTML={{ __html: stripOuterTags(author.description.childMarkdownRemark.html) }} />
        <AuthorContact email={author.email} />
      </div>

      {posts.map(renderList)}

      <Pagination currentPage={currentPage} numPages={numPages} contextPage={`author/${createSlug(author.name)}`} />
    </Layout>
  );
};

export default BlogAuhor;
